import capitalize from 'capitalize'
import SvgLogo from '#/assets/images/logos/app-icon.svg'
import Breadcrumb from '#/components/Breadcrumb'
import Link from '#/components/Link'
import factsString from '#/containers/Sitemap/factsString'

type SitemapProps = {
  sitemap: {
    url: string
    title?: string
    items: {
      url: string
      title: string
    }[]
    metrics?: number[],
    name?: string
    pageCount?: number
    error?: boolean
  },
  components: string[]
}

export default function Sitemap({ components, sitemap }: SitemapProps) {
  function formatBreadcrumbText(index: number, e: string): string {
    let result

    if (index <= 1) {
      // USA + State
      result = e.toUpperCase()
    } else {
      // Rest of the elements
      result = capitalize.words(e.replace('-', ' '))
    }

    // Append 'County' to counties
    if (index === 2) {
      result += ' County'
    }

    return result
  }

  const propertyLinksToShow = sitemap.items.slice(0, 25)

  return (
    <div className='ml-4'>
      <Breadcrumb className='mt-6'>
        <SvgLogo className='mr-3' />
        {components.map((e, index) => (
          <Breadcrumb.Item key={e + index}>
            <Link
              href={`/sitemap/${components
                .slice(0, index + 1)
                .join('/')}`}
            >
              <span className='mt-2 text-xs text-gray-500'>{formatBreadcrumbText(index, e)}</span>
            </Link>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
      <div className='mt-1'>
        <ul className='list-none columns-1 gap-4 sm:columns-2 lg:columns-3' style={{ columnFill: 'balance' }}>
          {propertyLinksToShow.map((e: any, index: any) => (
            <li key={index} className='inline-block w-full p-2'>
              {e.url.startsWith('/homes/details') && (
                <Link href={e.url}>
                  <span className='mt-2 text-xs font-bold'>{e.title}</span> <span className='text-xs'>{factsString(e.metrics)}</span>
                </Link>
              )}
            </li>
          ))}
          {(sitemap.pageCount || 0) > 1 ? (
            <li key='more_sitemap' className='inline-block w-full p-2'>
              <Link
                href={`/sitemap/${components
                  .slice(0, components.length)
                  .join('/')}`}
              >
                <span className='mt-2 text-xs font-bold'>View more properties on {formatBreadcrumbText(components.length - 1, components[components.length - 1])}</span>
              </Link>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  )
}
